import { Footer as AuroraFooter, LogoPrimaryCP } from '@consumidor-positivo/aurora';
import useRenegAppExperiment from '@common/abtest/experiments/useRenegAppExperiment';
import { useSecretTap } from '@consumidor-positivo/ts-utils/react';

import "./style.scss"

export const Footer = () => {
  const { forceRenegAppVariant } = useRenegAppExperiment();
  const handleSecretTap = useSecretTap(forceRenegAppVariant);

  return (
    <div className="footer-holder">
      <AuroraFooter
        certificates={['sslblindado', 'reclameaqui']}
        copyrights={
          <>
            © Copyright 2025 <span onClick={handleSecretTap}>Consumidor Positivo Ltda.</span> <br />
            Todos os direitos reservados / CNPJ: 30.247.128/0001-15
          </>
        }
        logo={<LogoPrimaryCP />}
        socialLinks={{
          facebook: 'https://facebook.com',
          instagram: 'https://instagram.com',
          linkedin: 'https://linkedin.com',
          youtube: 'https://youtube.com',
        }}
      />
    </div>
  );
};
